import gql from 'graphql-tag';

export const addPropertyExternalReferences = gql(/* GraphQL */ `
  mutation addPropertyExternalReferences(
    $channel: ChannelInput!
    $externalReferences: [ExternalReferenceAddInput!]!
  ) {
    addPropertyExternalReferences(
      channel: $channel
      externalReferences: $externalReferences
    ) {
      successful {
        id
        direct
        source {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        relationshipSource {
          sourceType
          sourceRelationshipType
          sourceRelationshipId
        }
      }
      failed {
        sourceEntityId
        sourceType
      }
    }
  }
`);
